/** Returns the complete calendar period selected by a sensor-history control. */
export function getSensorHistoryAxisRange(
    months: number,
    referenceDate = new Date(),
): [string, string] {
    const from = new Date(referenceDate);

    from.setUTCMonth(from.getUTCMonth() - months);

    return [from.toISOString(), referenceDate.toISOString()];
}
